var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(!this.$vuetify.theme.dark && _vm._iOS && _vm._nS)?_c('v-sheet',{attrs:{"color":"primary","height":"44"}}):_vm._e(),_c('transition',{attrs:{"name":"slide-x-transition","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }